import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";
import { getBoardDevice } from "./-components/board-api";
import { boardMode } from "./-components/board-mode";
import { BoardWelcome } from "./-components/board-welcome";
import { BoardForFacility } from "@/routes/sarah/board/-components/board-for-facility";
import { StaffBoard } from "@/routes/sarah/board/-components/staff-board";

export const Route = createFileRoute("/sarah/board/")({
  // No-op for a device or anonymous visitor (no `me`); the API refuses regardless of credential.
  beforeLoad: ({ context }) => guardRoute(context.me, "sarah-board"),
  component: HandoffBoard,
});

// Full viewport, outside the app shell: a wall display. Three modes (see `board-mode.ts`): a paired
// tablet (fixed building, no session, quick code per action), a signed-in person (their session
// names them), and nobody (welcome door; the route sits outside `_authenticated`).
function HandoffBoard() {
  const { me } = Route.useRouteContext();
  // Read once: activating or losing a registration reloads the page.
  const [device] = useState(getBoardDevice);

  // The registration decides before the session; see `board-mode.ts`.
  const mode = boardMode(device, me !== null);
  if (mode.kind === "device") return <BoardForFacility facilityId={mode.facilityId} />;
  if (mode.kind === "welcome") return <BoardWelcome />;
  return <StaffBoard />;
}
